export const IS_COMPARE_KEY = "isCompareKey";